import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f95d4306"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-page" }
const _hoisted_2 = {
  class: "ui-dashboard-indicadores",
  style: {"display":"none"}
}
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col ant-col-xs-24 ant-col-xl-12",
    style: {"text-align":"left"}
  }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col ant-col-xs-24 ant-col-xl-12",
    style: {"text-align":"right"}
  }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Últimas ocorrências")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_indicador_numero = _resolveComponent("indicador-numero")!
  const _component_ocorrencias_mapa = _resolveComponent("ocorrencias-mapa")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_indicador_numero, {
                  titulo: "Chamados em Aberto",
                  valor: 0
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_indicador_numero, {
                  titulo: "Total Chamados",
                  valor: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_indicador_numero, {
                  titulo: "Total Ocorrências",
                  valor: 0
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_indicador_numero, {
                  titulo: "Total Notificações",
                  valor: 0
                })
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_indicador_numero, {
                  titulo: "Total Interdições",
                  valor: 0
                })
              ])
            ]),
            _createElementVNode("div", null, [
              _hoisted_8,
              _createVNode(_component_ocorrencias_mapa, { mapId: 'd92fc09431b9432f9ac1c46a' })
            ])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}